var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"footer"},[_c('div',{staticClass:"footer-copyright-center"},[_vm._v(" Natural Phone 2023 todos los derechos reservados | terminos y condiciones | politicas de privacidad ")])])
}]

export { render, staticRenderFns }